import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { KIOSK_CART_PRODUCTS_LIST_BLOCK_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { previewScenarioForBloc$ } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';
import type { KioskCartProductsListBlockScenarioContent } from '@front-platform/content-builder';

import {
  KIOSK_CART_PRODUCTS_LIST_BLOCK_LOADING_VM,
  KioskCartProductsListBlockDataSource,
  KioskCartProductsListBlockViewModel,
} from './kiosk-cart-products-list-block-view-model';

@Injectable()
export class KioskCartProductsListBlockPreviewDataSource implements KioskCartProductsListBlockDataSource {
  readonly vm$: Observable<KioskCartProductsListBlockViewModel> = previewScenarioForBloc$(
    KIOSK_CART_PRODUCTS_LIST_BLOCK_COMPONENT,
  ).pipe(
    map(scenario => {
      if (!scenario) {
        return KIOSK_CART_PRODUCTS_LIST_BLOCK_LOADING_VM;
      }

      const content = previewScenarioData<KioskCartProductsListBlockScenarioContent>(
        scenario,
        KIOSK_CART_PRODUCTS_LIST_BLOCK_COMPONENT,
      ) as Omit<KioskCartProductsListBlockViewModel, 'cartProducts'> | null;

      if (!content) {
        return KIOSK_CART_PRODUCTS_LIST_BLOCK_LOADING_VM;
      }

      return {
        ...content,
        cartProducts: [],
      } satisfies KioskCartProductsListBlockViewModel;
    }),
  );
}
